import React, { useState } from 'react';
import {
  FormControl,
  Input,
  FormErrorMessage,
  InputGroup,
  InputRightElement,
  IconButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const PasswordInput = ({ register, errors, name, placeholder, validation, variant }) => {
  const [showPassword, setShowPassword] = useState(false);
  const iconColor = useColorModeValue('gray.600', 'gray.300');

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <FormControl isInvalid={!!errors[name]} mt={4}>
      <InputGroup>
        <Input
          type={showPassword ? 'text' : 'password'}
          placeholder={placeholder}
          variant={variant || "filled"}
          pr="3rem"
          {...register(name, validation)}
        />
        <InputRightElement width="3rem">
          <IconButton
            variant="ghost"
            size="sm"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            icon={showPassword ? <FiEyeOff color={iconColor} /> : <FiEye color={iconColor} />}
            onClick={togglePasswordVisibility}
            onMouseDown={(e) => e.preventDefault()} // Prevent input blur on icon click
            _hover={{ bg: 'transparent' }}
          />
        </InputRightElement>
      </InputGroup>
      <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>
    </FormControl>
  );
};

export default PasswordInput;